module.exports = __webpack_public_path__ + "../resources/img/ic_undo_gray950.dc8d7fd8.svg";